"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _constants = require("../../../constants");

var _commonUIColors = require("../../../utils/commonUIColors");

var _useTranslations = _interopRequireDefault(require("../../../utils/useTranslations"));

var _Grid = _interopRequireDefault(require("../../Grid"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Typography = require("../../Typography");

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _proptypeValidators = require("../proptypeValidators");

var _components = require("./components");

var _schema = _interopRequireDefault(require("../schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var actionProps = [{
  size: 'small'
}, {
  kind: 'secondary',
  size: 'small'
}];

function Notification(props) {
  var actions = props.actions,
      children = props.children,
      closeHint = props.closeHint,
      colorProp = props.color,
      icon = props.icon,
      id = props.id,
      _props$intent = props.intent,
      intent = _props$intent === void 0 ? _constants.intentNames.information : _props$intent,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onHover = props.onHover,
      title = props.title;
  var translate = (0, _useTranslations.default)();

  var _React$useMemo = _react.default.useMemo(function () {
    var intentValues = intent && _constants.intents[intent] || {};
    var finalColor = (0, _toColorString.default)(colorProp ? _commonUIColors.statusColors[colorProp] || (0, _get.default)(intentValues, 'color') : (0, _get.default)(intentValues, 'color'));
    var IconComponent = icon || (0, _get.default)(intentValues, 'icon');
    return [_react.default.createElement(IconComponent, {
      color: finalColor
    }), finalColor];
  }, [colorProp, icon, intent]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      Icon = _React$useMemo2[0],
      accentColor = _React$useMemo2[1];

  return _react.default.createElement(_components.NotificationCard, {
    id: id,
    borderColor: accentColor,
    margin: 0,
    padding: 1.5,
    onFocus: onFocus,
    onMouseOver: onHover
  }, _react.default.createElement(_Grid.default.Row, null, _react.default.createElement(_components.IconColumn, null, Icon), _react.default.createElement(_Grid.default.Column, null, _react.default.createElement(_Grid.default.Row, null, _react.default.createElement(_Grid.default.Column, null, _react.default.createElement(_Typography.P, {
    shade: 0,
    weight: "semibold"
  }, title)), onClose && _react.default.createElement(_components.IconColumn, {
    right: true
  }, _react.default.createElement(_Tooltip.default, {
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement(_components.CloseButton, {
      "aria-label": translate(closeHint, 'notification.closeHint'),
      icon: _Times.default,
      onClick: onClose,
      size: "small",
      variant: "ghost"
    }),
    zIndex: 100
  }, translate(closeHint, 'notification.closeHint')))), children && _react.default.createElement(_Grid.default.Row, {
    marginBottom: actions ? 0.5 : 0
  }, _react.default.createElement(_Grid.default.Column, null, _react.default.createElement(_Typography.P, {
    as: "div",
    shade: 1,
    size: "small"
  }, children))), actions && _react.default.createElement(_Grid.default.Row, {
    marginTop: 1
  }, _react.default.createElement(_Grid.default.Column, null, actions.map(function (action, index) {
    return _react.default.createElement(_components.ActionButtonContainer, {
      key: action.text
    }, _react.default.createElement(_Button.default, _extends({}, (0, _omit.default)(action, ['kind', 'size', 'variant']), actionProps[index])));
  }))))));
}

var propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _proptypeValidators.actionsValidator,
  children: _propTypes.default.node,
  icon: _propTypes.default.elementType,
  id: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func
});

var defaultProps = {
  actions: undefined,
  children: null,
  icon: undefined,
  onClose: undefined
};
Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;
Notification.displayName = 'Notification';
var _default = Notification;
exports.default = _default;